import { generateClasses } from '@formkit/themes'
import images from '@/components/formkit/images'
import rating from '@/components/formkit/rating'
import phone from '@/utils/validation/isPhoneNumber'
import nip from '@/utils/validation/isNip'
import zipcode from '@/utils/validation/isZipcode'

import {
  outer,
  inner,
  wrapper,
  label,
  messages,
  message,
  textInput,
  textareaInput,
  help
} from '@formkit/inputs'

const config = {
  inner: 'relative h-[40px]',
  input: 'peer success:border-green error:border-red placeholder:text-transparent placeholder:select-none transition-color duration-200 ease-in w-full h-full disabled:bg-transparent disabled:text-gray-400 disabled:cursor-not-allowed border border-gray-400 disabled:border-gray-300 px-[20px] text-16 rounded',
  label: 'peer-not-placeholder-shown:text-12 peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:left-[5px] error:text-red text-placeholder peer-disabled:text-placeholder-disabled top-1/2 left-[10px] peer-focus:text-12 peer-focus:top-0 peer-focus:left-[5px] peer-autofill:text-12 peer-autofill:top-0 peer-autofill:left-[5px] transition-all duration-200 ease-in absolute -translate-y-1/2 px-[5px] pointer-events-none bg-white',
  message: 'text-red text-12'
}

const checkboxConfig = {
  inner: 'mt-[10px] error:text-red text-10 inline-flex gap-[5px]',
  input: 'error:ring-1 error:ring-red error:ring-inset shrink-0 w-[14px] h-[14px] accent-action cursor-pointer',
  message: 'text-red text-12'
}

const radioConfig = {
  wrapper: 'flex items-center gap-[10px] py-[10px]',
  message: 'text-red text-12'
}

const textareaConfig = {
  outer: 'flex flex-col',
  inner: 'relative flex mt-[10px]',
  input: 'peer error:border-red success:border-green placeholder:text-transparent placeholder:select-none transition-color duration-200 ease-in w-full h-full disabled:bg-transparent disabled:text-gray-400 disabled:cursor-not-allowed border border-gray-400 disabled:border-gray-300 px-[20px] rounded resize-none pt-[10px] text-16',
  label: 'text-placeholder peer-disabled:text-placeholder-disabled peer-not-placeholder-shown:text-12 peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:left-[5px] error:text-red top-[15px] left-[10px] peer-focus:text-12 peer-focus:top-0 peer-focus:left-[5px] peer-autofill:text-12 peer-autofill:top-0 peer-autofill:left-[5px] transition-all duration-200 ease-in absolute -translate-y-1/2 px-[5px] pointer-events-none bg-white',
  help: 'flex justify-end text-12 text-gray-400',
  message: 'text-red text-12'
}

const imagesConfig = {
  label: 'text-16',
  message: 'text-red text-12'
}

const ratingConfig = {
  inner: 'group',
  icon: 'icon-star'
}

const inputs = {
  schema: outer(
    wrapper(
      inner(
        textInput(),
        label('$label')
      )
    ),
    messages(message('$message.value'))
  )
}

const textarea = {
  schema: outer(
    wrapper(
      inner(
        textareaInput(),
        label('$label')
      )
    ),
    help('$help'),
    messages(message('$message.value'))
  )
}

export default {
  config: {
    classes: generateClasses({
      form: {
        message: 'text-red text-12'
      },
      text: config,
      tel: config,
      email: config,
      password: config,
      search: config,
      checkbox: checkboxConfig,
      radio: radioConfig,
      textarea: textareaConfig,
      images: imagesConfig,
      rating: ratingConfig
    })
  },
  inputs: {
    text: inputs,
    tel: inputs,
    email: inputs,
    password: inputs,
    search: inputs,
    textarea,
    images,
    rating
  },
  rules: {
    phone,
    nip,
    zipcode
  }
}
